import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { ProjectAnalysisScreen } from "../../screen/ProjectAnalysisScreen";
import { useScope } from "../SelectProjectCompanyContainer";
import Send from "../../core/communication";
import { SubheaderFilter } from "../../components/Subheader";
import { getLabelTranslate } from "../../core/utils/events/labelTranslate";
import {
  getCurrentPercent,
  getLastRegisterData,
  getDataByTrimester,
  getMeanByMonth,
  groupEventsByMonth,
  getDataByFilterReference,
  formatDateChart
} from "../../core/utils/hooks/useSCD";
import { setData } from "../../core/redux/app/Actions";
import { useFilter } from "../../core/utils/hooks/useFilter";
import { useUsers } from "../../core/utils/hooks/useUsers";

const dataPieLabel = [
  { label: "Assistencia", title: "Produtores em Assistência Técnica" },
  { label: "Desconexao", title: "Produtores Desconectados" },
  { label: "Educacao", title: "Produtores em Educação" },
  { label: "Transformacao", title: "Produtores em Transformação Digital" },
];

const pivotEvents = async (eventData) => {
  eventData = eventData.sort((a, b) => {
    if (a?.event_month < b?.event_month) return -1
    if (a?.event_month > b?.event_month) return 1
    return 0
  })

  let [latestRecords] = getLastRegisterData(eventData, "year");
  const { eventList, groupedData } = groupEventsByMonth(latestRecords, 'event_month');

  if (!latestRecords || latestRecords.length === 0) return [];

  const response = eventList.map((event_name) => ({
    x: groupedData
    .filter((item) => item?.evento === event_name)
    .map((item) => item?.event_date),
    y: groupedData
      .filter((item) => item?.evento === event_name)
      .map((item) => item?.qtde_produtor),
    mode: "lines+markers",
    type: "scatter",
    name: getLabelTranslate(event_name),
  }))

  return response
}

const formatNps = async (data, filteredYear, filteredPeriod) => {
  if (!data || !data.length) {
    return
  }

  const [latestRecords, lastYear] = getLastRegisterData(data, "year_nps", filteredYear)
  const meanTrimester = getDataByTrimester(data, "year_nps", filteredPeriod)
  
  const meanByMonth = getMeanByMonth(latestRecords, "month_nps", "nps")

  return { lastYear, meanByMonth, meanTrimester } || {}
}

const formatNpsReference = async (kpi, filteredPeriod) => {
  if (!kpi.data || !kpi.data.length && !kpi.reference || !kpi.reference.length) return [];

  if(filteredPeriod.yearReference && !filteredPeriod.year){
    return formatDateChart(kpi?.reference[0])
  }

  return getDataByFilterReference(kpi)
};

const tagsPercentToNumber = (data) => {
  if(!data || !data.length) return [];

  let newData = data;

  newData = data.map((currentValue) => {
    console.log(currentValue)
    if(data[0]?.Assistencia && data[0]?.Desconexao && data?.Educacao && data?.Transformacao){
      return currentValue
    }

    return {
      ...currentValue,
      Assistencia: parseInt((currentValue?.IndiceAssistencia * currentValue?.contactados) / 100, 10), 
      Desconexao: parseInt((currentValue?.IndiceDesconexao * currentValue?.contactados) / 100, 10), 
      Educacao: parseInt((currentValue?.IndiceEducacao * currentValue?.contactados) / 100, 10), 
      Transformacao: parseInt((currentValue?.IndiceTransformacao * currentValue?.contactados) / 100, 10), 
    }
  })

  return newData;
}

const formatDw = async (data, filteredYear) => {
  if (!data || !data.length) {
    return {}
  }

  let [atendimento, contactados, prospeccao, Assistencia, Desconexao, Educacao, Transformacao] = [
    0, 0, 0, 0, 0, 0, 0,
  ]

  const [latestRecords, lastYear] = getLastRegisterData(data, "year_project", filteredYear)

  latestRecords.map((item) => {
    atendimento += item?.atendimento || 0
    contactados += item?.contactados || 0
    prospeccao += item?.prospeccao || 0
    Assistencia += item?.Assistencia || 0
    Desconexao += item?.Desconexao || 0
    Educacao += item?.Educacao || 0
    Transformacao += item?.Transformacao || 0
  })

  return {
    atendimento: {
      value: atendimento,
      percent: getCurrentPercent(data[0].data, "contactados", "atendimento", "year_project"),
    },
    prospeccao: {
      value: prospeccao,
      percent: getCurrentPercent(data[0].data, "contactados", "prospeccao", "year_project"),
    },
    contactados,
    Assistencia,
    Desconexao,
    Educacao,
    Transformacao,
    lastYear,
  }
}

const getFilterSettings = (projects, valuesToSearch, scope, scopeType) => {
  let extraQuery = ""
  let newProjects = projects || []
  let type = 'project';

  if (!Array.isArray(newProjects) || !newProjects.length) {
    newProjects = [{ value: scope?.id }];
    type = scopeType;
  }

  newProjects = newProjects?.filter((item) => item?.value)
    .map((project) => (project.label !== "Ambev" ? `'${project?.value}'` : project?.value))
    .toString()

  if (valuesToSearch?.year) {
    const start = `${valuesToSearch?.year}`.split("|")[0]
    const end = `${valuesToSearch?.year}`.split("|")[1]
    extraQuery += `&start=${start}&end=${end}`
  }

  if (valuesToSearch?.yearReference) {
    const start = `${valuesToSearch?.yearReference}`.split("|")[0]
    const end = `${valuesToSearch?.yearReference}`.split("|")[1]
    extraQuery += `&startReference=${start}&endReference=${end}`
  }

  return { projects: newProjects, extraQuery, scopeType: type }
}

const getDateLabels = (yearEnd, yearReferenceEnd, isDate = false) => {
  if(!yearEnd || !yearReferenceEnd) return ['',''];

  if(isDate) {
    const [dateStart, dateEnd] = `${yearEnd}`.split("|") || ['','']
    const [dateReferenceStart, dateReferenceEnd] = `${yearReferenceEnd}`.split("|") || ['','']
    return [
      `${moment(dateStart).format('DD/MM/YYYY')} - ${moment(dateEnd).format('DD/MM/YYYY')}`,
      `${moment(dateReferenceStart).format('DD/MM/YYYY')} - ${moment(dateReferenceEnd).format('DD/MM/YYYY')}`,
    ]
  }

  if(moment(yearEnd) > moment(yearReferenceEnd)) {
    return [
      `Data Inicial - `,
      `Data de Referência - `
    ]
  } else if(moment(yearEnd) <= moment(yearReferenceEnd)) {
    return [
      `Data de Referência - `,
      `Data Inicial - `
    ]
  }
}

const ProjectAnalysisContainer = () => {
  const { scope, scopeType, projectsByScope } = useScope();
  const users = useSelector((state) => state.app.users)
  const { reload: reloadUser } = useUsers()
  const [valuesToSearch, onChange, reload, onReload] = useFilter('period-filter');
  const projectModuleData = useSelector((state) => state.app.projectModule) || {
    pieChart: {},
    dataBarChart: {},
    dwCards: {},
    events: {}
  };
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const lastYear = useSelector((state) => state.app.lastYear);

  const settings = getFilterSettings(valuesToSearch?.projects || [], valuesToSearch, scope, scopeType)

  useEffect(() => {
    const newProjects = valuesToSearch?.projects && valuesToSearch.projects.filter(row => row?.value);
    if(!Array.isArray(newProjects) || !newProjects.length) {
      const formattedProjects = projectsByScope.map(row => ({ value: row?.id, label: row?.description }));
      onChange('projects', formattedProjects);
    }
  }, [reload, scope?.id])

  const loadAllData = async () => {
    
    setLoading(true);
    const [newNpsData, newEvents, { newPieChart, newDwCards, newLastYear }] = await Promise.all([
      loadNps(settings),
      loadEvents(settings),
      loadDw(settings),
    ])
    setLoading(false);

    dispatch(
      setData({
        projectModule: {
          ...projectModuleData,
          pieChart: newPieChart || {},
          dwCards: newDwCards || {},
          npsBarChart: newNpsData || {},
          events: newEvents
        },
        lastYear: lastYear || newLastYear
      }),
    )
    
  }

  useEffect(() => {
    if(reload){
      loadAllData()
    }
  }, [reload])

  useEffect(() => {
    if(scope?.id){
      onReload()
    }
  },[scope?.id])

  const loadEvents = async ({ projects, extraQuery, year, scopeType }) => {
    const dwEventsProducer = await Send.get(
      "/DW/countEventsProducer",
      `projects=${projects}${extraQuery}&byMonth=true&scopeType=${scopeType}`,
    )

    const dataEvents = await pivotEvents(dwEventsProducer?.data || [], year || lastYear);
    const referenceEvents = valuesToSearch?.year && valuesToSearch?.yearReference && await pivotEvents(dwEventsProducer?.reference || [], year || lastYear) || [];

    return {
      data: dataEvents || [],
      reference: referenceEvents || [],
      date: getDateLabels(
        valuesToSearch?.year,
        valuesToSearch?.yearReference,
        true
      ) || ['','']
    }
  }

  const loadDw = async ({ projects, extraQuery, scopeType }) => {
    const dwProject = await Send.get("/dw/kpi/project", `projects=${projects}${extraQuery}&scopeType=${scopeType}`);
    const formattedDw = await formatDw(dwProject?.data || [], lastYear) || {};
    const dwWithoutOnboarding = await formatDw(dwProject?.dataWithoutOnboarding || [], lastYear) || {};
    const referenceWithoutOnboarding = await formatDw(dwProject?.referenceWithoutOnboarding || [], lastYear) || {};

    let [data, reference] = [[], []];

    const [yearEndLabel, yearReferenceEndLabel] = getDateLabels(
      `${valuesToSearch?.year || ''}`.split("|")[1],
      `${valuesToSearch?.yearReference || ''}`.split("|")[1]
    );

    dataPieLabel.map((item) => {
      data.push({
        name: `${yearEndLabel}${item?.title}`,
        value: dwWithoutOnboarding[item?.label] || 0,
      })

      reference.push({
        name: `${yearReferenceEndLabel}${item?.title}`,
        value: referenceWithoutOnboarding[item?.label] || 0,
      })
    })

    reloadUser()

    return { newPieChart: {data, reference}, newDwCards: {dwWithoutOnboarding: formattedDw , referenceWithoutOnboarding}, newLastYear: formattedDw?.lastYear };
  }

  const loadNps = async ({ projects, extraQuery, scopeType }) => {
    const kpiNps = await Send.get("/dw/kpi/NPS", `projects=${projects}${extraQuery}&scopeType=${scopeType}`);

    const formattedNps = Array.isArray(kpiNps?.data) ? await formatNps(kpiNps?.data, lastYear, valuesToSearch?.year) : {}
    const referenceNPS = Array.isArray(kpiNps?.reference) && await formatNpsReference(kpiNps, valuesToSearch)
    const [data, reference] = [formattedNps, referenceNPS];

    return { data: data?.meanByMonth || [], dataTri: data?.meanTrimester || [], reference: reference || [] };
  }

  const dataTotal = projectModuleData?.dwCards?.dwWithoutOnboarding
  const dataReference = projectModuleData?.dwCards?.referenceWithoutOnboarding
  
  const totalEducacao = projectModuleData?.pieChart?.data?.filter(item => item.name.includes("Educação"))[0]?.value || 0
  const referenceEducacao = projectModuleData?.pieChart?.reference?.filter(item => item.name.includes("Educação"))[0]?.value || 0
  const totalAssistance = projectModuleData?.pieChart?.data?.filter(item => item.name.includes("Assistência"))[0]?.value + totalEducacao || 0
  const referenceAssistance = projectModuleData?.pieChart?.reference?.filter(item => item.name.includes("Assistência"))[0]?.value + referenceEducacao || 0
  const totalProspeccao = projectModuleData?.pieChart?.data?.filter(item => item.name.includes("Transformação"))[0]?.value || 0
  const referenceProspeccao = projectModuleData?.pieChart?.reference?.filter(item => item.name.includes("Transformação"))[0]?.value || 0

  const totalContactados = !loading && users?.map((item) => {
    return item?.tag_user?.filter(
      (tag) =>
        !!tag.id &&
        !tag.name?.includes("Assistência técnica") &&
        !tag.name?.includes("Transformação") &&
        !tag.name?.includes("Prospecção") &&
        !tag.name?.includes("Desconexão") &&
        !tag.name?.includes("Educação"),
    )
  })?.length || 0

  return (
    <div>
      <SubheaderFilter
        {...{
          setLoading,
          loading,
          dateType: 1,
          periodReference: true,
          hasFixedYear: true,
          fixedYear: lastYear,
          removeFiltersNoProject: true,
          keyFilter: 'period-filter'
        }}
      />
      <ProjectAnalysisScreen
        {...{
          barChart: projectModuleData?.npsBarChart,
          loading,
          dwProject: projectModuleData?.dwCards,
          pieChart: projectModuleData?.pieChart,
          events: projectModuleData?.events,
          totalAssistance,
          referenceAssistance,
          totalProspeccao,
          referenceProspeccao,
          totalContactados
        }}
      />
    </div>
  )
}

export default ProjectAnalysisContainer
